module.exports = __webpack_public_path__ + "img/mindmap-1.26d7b4cb.svg";